// import { DiyMoveStepModule as v1 } from './diy-move-v1/diy-move.module';
import { DiyMoveStepModule as v2 } from './diy-move-v2/diy-move-v2.module';

// Leaving this to show how easy it is to flip v1() back on if we needed to
// const DiyMoveStepModule = localStorage.getItem('upd-diy-v2') ? v2() : v1();

const DiyMoveStepModule = v2();

export { DiyMoveStepModule };
